<template>
  <div
    id="toastNotif"
    class="toast border-0 shadow"
    :class="'toast--' + notif.status"
    role="alert"
    aria-live="assertive"
    aria-atomic="true"
  >
    <div class="toast-body d-flex align-items-center gap-2">
      <i class="toast-icon fs-20" :class="iconClass"></i>
      <span class="fs-14" v-html="notif.message" />
      <button type="button" class="btn-close btn-close-white ms-auto" data-bs-dismiss="toast" aria-label="Close"></button>
    </div>
  </div>
</template>

<script>
import { computed, nextTick, onMounted, ref, watch } from 'vue'
import { Toast } from 'bootstrap'
import { notif, resetNotif } from '@/core/utility'

export default {
  setup () {
    const toast = ref(null)

    const iconClass = computed(() => {
      if (notif.status === 'success') return 'ri-checkbox-circle-fill'
      if (notif.status === 'error') return 'ri-close-circle-fill'
      return 'ri-information-fill'
    })

    onMounted(() => {
      const toastElement = document.getElementById('toastNotif')
      toast.value = new Toast(toastElement, {
        animation: true,
        autohide: true,
        delay: 3000
      })

      toastElement.addEventListener('hidden.bs.toast', function () {
        resetNotif()
      })
    })

    watch(notif, (newNotif) => {
      if (newNotif.show) {
        nextTick(() => toast.value.show())
      }
    }, { deep: true })

    return { notif, iconClass }
  }
}
</script>

<style scoped>
.toast {
  min-width: 280px;
  border-radius: 12px;
}

.toast--success {
  background-color: #8CC63F;
  color: white;
}

.toast--error {
  background-color: #E21F39;
  color: white;
}

.toast--warning {
  background-color: #FF9D0A;
  color: white;
}

.toast:not(.showing):not(.show) {
  display: none;
}

.toast-icon {
  flex-shrink: 0;
}
</style>
